module.exports = " <input type=text v-model=data class=form-control /> <div class=video-preview-wrapper v-if=\"isEmbeddable || isVideo\"> <div class=video-preview> <iframe v-if=isEmbeddable width=560 height=315 src=\"{{ embed }}\" frameborder=0 allowfullscreen></iframe> <video controls v-if=isVideo :src=embed width=560 height=315></video> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/fieldtypes/VideoFieldtype.vue
// module id = 785
// module chunks = 0